export default __webpack_public_path__ + "static/media/googleplay.6ef08c3b.png";